"use strict";

exports.__esModule = true;
exports.BI_UOU_SRC = exports.BI_UOU_ENDPOINT = void 0;
var BI_UOU_ENDPOINT = 'blog-app-uou';
exports.BI_UOU_ENDPOINT = BI_UOU_ENDPOINT;
var BI_UOU_SRC = 69;
exports.BI_UOU_SRC = BI_UOU_SRC;